export default __webpack_public_path__ + "static/media/plans-subscribe.974c2676.jpg";